import { PARTIES_ERROR_MESSAGES, USER_ROLE } from 'src/appConfig/constanst';
import StatusTag from 'src/components/common/StatusTag';
import { People } from 'src/dataFactory/depositionFactory';
export const StatusOptions = {
  isRejected: 'REJECTED',
  isPending: 'PENDING',
  isActive: 'ACTIVE',
  isComplete: 'COMPLETED',
};
export const getDepoStatusTab = (value: string) => {
  if (!value) return '---';

  return (
    <StatusTag
      variant={
        value === StatusOptions.isActive
          ? 'is-active'
          : value === StatusOptions.isComplete
          ? 'is-complete'
          : value === StatusOptions.isPending
          ? 'is-pending'
          : 'is-reject'
      }>
      {value.toLowerCase()}
    </StatusTag>
  );
};
export const validateParties = (data: People[]) => {
  if (!data || data.length === 0) return PARTIES_ERROR_MESSAGES.REQUIRED;

  const courtReportes = data.filter(p => p.position === USER_ROLE.CourtReporter);
  const clientReportes = data.filter(p => p.position === USER_ROLE.Client);
  if (!(courtReportes.length === 1 && clientReportes.length >= 1)) return PARTIES_ERROR_MESSAGES.QUANTITY;

  return null;
};
